import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Fixed Deposit Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const FixedDepositView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="fixed-deposit"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default FixedDepositView;
